require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.string.trim");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("ReactSimpleTreeMenu", ["react"], t) : "object" == typeof exports ? exports.ReactSimpleTreeMenu = t(require("react")) : e.ReactSimpleTreeMenu = t(e.react);
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/dist/", r(r.s = 3);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.defaultChildren = t.ItemComponent = void 0;
    var n = a(r(0)),
        o = a(r(10));

    function a(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var _i = function i() {
      return (_i = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) {
          for (var o in t = arguments[r]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        c = function c(e, t) {
      var r = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) {
          t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
        }
      }

      return r;
    },
        u = function u(e) {
      var t = e.on,
          r = e.openedIcon,
          o = e.closedIcon;
      return n["default"].createElement("div", {
        role: "img",
        "aria-label": "Toggle",
        className: "toggle-icon-symbol"
      }, t ? r : o);
    },
        l = function l(e) {
      var t = e.hasNodes,
          r = void 0 !== t && t,
          a = e.isOpen,
          c = void 0 !== a && a,
          l = e.level,
          s = void 0 === l ? 0 : l,
          f = e.onClick,
          p = e.toggleNode,
          d = e.active,
          y = e.focused,
          v = e.openedIcon,
          h = void 0 === v ? "-" : v,
          m = e.closedIcon,
          b = void 0 === m ? "+" : m,
          g = e.label,
          O = void 0 === g ? "unknown" : g,
          j = e.style,
          N = void 0 === j ? {} : j;
      return n["default"].createElement("li", {
        className: (0, o["default"])("tree-item", {
          "tree-item--active": d
        }, {
          "tree-item--focused": y
        }),
        style: _i({
          paddingLeft: .75 + 2 * (r ? 0 : 1) + 1.75 * s + "rem"
        }, N),
        role: "button",
        "aria-pressed": d,
        onClick: f
      }, r && n["default"].createElement("div", {
        className: "toggle-icon",
        onClick: function onClick(e) {
          r && p && p(), e.stopPropagation();
        }
      }, n["default"].createElement(u, {
        on: c,
        openedIcon: h,
        closedIcon: b
      })), O);
    };

    t.ItemComponent = l;

    t.defaultChildren = function (e) {
      var t = e.search,
          r = e.items;
      return n["default"].createElement(n["default"].Fragment, null, t && n["default"].createElement("input", {
        className: "search",
        "aria-label": "Type and search",
        type: "search",
        placeholder: "Type and search",
        onChange: function onChange(e) {
          var r = e.target.value;
          t && t(r);
        }
      }), n["default"].createElement("ul", {
        className: "tree-item-group"
      }, r.map(function (e) {
        var t = e.key,
            r = c(e, ["key"]);
        return n["default"].createElement(l, _i({
          key: t
        }, r));
      })));
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n,
        o = (n = r(0)) && n.__esModule ? n : {
      "default": n
    };

    var a = function a(e) {
      var t = e.children,
          r = e.up,
          n = e.down,
          a = e.left,
          i = e.right,
          c = e.enter;
      return o["default"].createElement("div", {
        tabIndex: 0,
        onKeyDown: function onKeyDown(e) {
          switch (e.key) {
            case "ArrowUp":
              r();
              break;

            case "ArrowDown":
              n();
              break;

            case "ArrowLeft":
              a();
              break;

            case "ArrowRight":
              i();
              break;

            case "Enter":
              c();
          }
        }
      }, t);
    };

    t["default"] = a;
  }, function (e, t, r) {
    e.exports = r(4);
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "defaultChildren", {
      enumerable: !0,
      get: function get() {
        return o.defaultChildren;
      }
    }), Object.defineProperty(t, "ItemComponent", {
      enumerable: !0,
      get: function get() {
        return o.ItemComponent;
      }
    }), Object.defineProperty(t, "KeyDown", {
      enumerable: !0,
      get: function get() {
        return a["default"];
      }
    }), t["default"] = void 0;
    var n = i(r(5)),
        o = r(1),
        a = i(r(2));

    function i(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var c = n["default"];
    t["default"] = c;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n = u(r(0)),
        o = u(r(6)),
        a = u(r(7)),
        i = r(1),
        c = u(r(2));

    function u(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var _l,
        s = (_l = function l(e, t) {
      return (_l = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(e, t);
    }, function (e, t) {
      function r() {
        this.constructor = e;
      }

      _l(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
    }),
        _f = function f() {
      return (_f = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) {
          for (var o in t = arguments[r]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        p = function p(e, t) {
      var r = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) {
          t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
        }
      }

      return r;
    },
        d = function d() {
      for (var e = 0, t = 0, r = arguments.length; t < r; t++) {
        e += arguments[t].length;
      }

      var n = Array(e),
          o = 0;

      for (t = 0; t < r; t++) {
        for (var a = arguments[t], i = 0, c = a.length; i < c; i++, o++) {
          n[o] = a[i];
        }
      }

      return n;
    },
        y = function y(e) {
      return console.log(e);
    },
        v = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          openNodes: t.props.initialOpenNodes || [],
          searchTerm: "",
          activeKey: t.props.initialActiveKey || "",
          focusKey: t.props.initialFocusKey || ""
        }, t.resetOpenNodes = function (e) {
          var r = t.props.initialOpenNodes,
              n = Array.isArray(e) && e || r || [];
          t.setState({
            openNodes: n,
            searchTerm: ""
          });
        }, t.search = function (e) {
          var r = t.props.debounceTime;
          (0, o["default"])(function (e) {
            return t.setState({
              searchTerm: e
            });
          }, r)(e);
        }, t.toggleNode = function (e) {
          if (!t.props.openNodes) {
            var r = t.state.openNodes,
                n = r.includes(e) ? r.filter(function (t) {
              return t !== e;
            }) : d(r, [e]);
            t.setState({
              openNodes: n
            });
          }
        }, t.generateItems = function () {
          var e = t.props,
              r = e.data,
              n = e.onClickItem,
              o = e.locale,
              i = e.matchSearch,
              c = t.state.searchTerm,
              u = t.props.openNodes || t.state.openNodes,
              l = t.props.activeKey || t.state.activeKey,
              s = t.props.focusKey || t.state.focusKey;
          return (r ? (0, a["default"])({
            data: r,
            openNodes: u,
            searchTerm: c,
            locale: o,
            matchSearch: i
          }) : []).map(function (e) {
            var r = e.key === s,
                o = e.key === l,
                a = e.hasNodes ? function () {
              return t.toggleNode(e.key);
            } : void 0;
            return _f(_f({}, e), {
              focused: r,
              active: o,
              onClick: function onClick() {
                var r = t.props.activeKey || e.key;
                t.setState({
                  activeKey: r,
                  focusKey: r
                }), n && n(e);
              },
              toggleNode: a
            });
          });
        }, t.getKeyDownProps = function (e) {
          var r = t.props.onClickItem,
              n = t.state,
              o = n.focusKey,
              a = n.activeKey,
              i = (n.searchTerm, e.findIndex(function (e) {
            return e.key === (o || a);
          })),
              c = function c(e) {
            var t = e.key.split("/");
            return t.length > 1 ? t.slice(0, t.length - 1).join("/") : e.key;
          };

          return {
            up: function up() {
              t.setState(function (t) {
                var r = t.focusKey;
                return {
                  focusKey: i > 0 ? e[i - 1].key : r
                };
              });
            },
            down: function down() {
              t.setState(function (t) {
                var r = t.focusKey;
                return {
                  focusKey: i < e.length - 1 ? e[i + 1].key : r
                };
              });
            },
            left: function left() {
              t.setState(function (t) {
                var r = t.openNodes,
                    n = p(t, ["openNodes"]),
                    o = e[i],
                    a = r.filter(function (e) {
                  return e !== o.key;
                });
                return o.isOpen ? _f(_f({}, n), {
                  openNodes: a,
                  focusKey: o.key
                }) : _f(_f({}, n), {
                  focusKey: c(o)
                });
              });
            },
            right: function right() {
              var r = e[i],
                  n = r.hasNodes,
                  o = r.key;
              n && t.setState(function (e) {
                var t = e.openNodes;
                return {
                  openNodes: d(t, [o])
                };
              });
            },
            enter: function enter() {
              t.setState(function (e) {
                return {
                  activeKey: e.focusKey
                };
              }), r && r(e[i]);
            }
          };
        }, t;
      }

      return s(t, e), t.prototype.componentDidUpdate = function (e) {
        var t = this.props,
            r = t.data,
            n = t.initialOpenNodes,
            o = t.resetOpenNodesOnDataUpdate;
        e.data !== r && o && n && this.setState({
          openNodes: n
        });
      }, t.prototype.render = function () {
        var e = this.props,
            t = e.children,
            r = e.hasSearch,
            o = this.state.searchTerm,
            a = this.generateItems(),
            u = t || i.defaultChildren,
            l = this.getKeyDownProps(a);
        return n["default"].createElement(c["default"], _f({}, l), u(r ? {
          search: this.search,
          items: a,
          resetOpenNodes: this.resetOpenNodes,
          searchTerm: o
        } : {
          items: a,
          resetOpenNodes: this.resetOpenNodes
        }));
      }, t.defaultProps = {
        data: {},
        onClickItem: y,
        debounceTime: 125,
        children: i.defaultChildren,
        hasSearch: !0,
        resetOpenNodesOnDataUpdate: !1
      }, t;
    }(n["default"].Component);

    t["default"] = v;
  }, function (e, t) {
    e.exports = function (e, t) {
      var r = null;
      return function () {
        clearTimeout(r);
        var n = arguments,
            o = this;
        r = setTimeout(function () {
          e.apply(o, n);
        }, t);
      };
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n = a(r(8)),
        o = a(r(9));

    function a(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var _i2 = function i() {
      return (_i2 = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) {
          for (var o in t = arguments[r]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        c = function c(e, t) {
      var r = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) {
          t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
        }
      }

      return r;
    },
        u = function u() {
      for (var e = 0, t = 0, r = arguments.length; t < r; t++) {
        e += arguments[t].length;
      }

      var n = Array(e),
          o = 0;

      for (t = 0; t < r; t++) {
        for (var a = arguments[t], i = 0, c = a.length; i < c; i++, o++) {
          n[o] = a[i];
        }
      }

      return n;
    },
        l = function l(e) {
      return !!e && !(0, n["default"])(e);
    },
        s = function s(e) {
      return l(e) ? e : [];
    },
        f = function f(e) {
      var t,
          r = e.data,
          n = c(e, ["data"]),
          o = s(r),
          a = _i2({
        parent: "",
        level: 0
      }, n);

      return Array.isArray(o) ? o.reduce(function (e, t, r) {
        var n = _i2({
          node: t,
          index: r,
          nodeName: t.key
        }, a),
            o = y(n);

        return u(e, o);
      }, []) : (t = o, Object.entries(t).sort(function (e, t) {
        return e[1].index - t[1].index;
      }).reduce(function (e, t) {
        var r = t[0],
            n = t[1],
            o = _i2({
          node: n,
          nodeName: r
        }, a),
            c = y(o);

        return u(e, c);
      }, []));
    },
        p = function p(e) {
      var t = e.label,
          r = e.searchTerm,
          n = function n(e) {
        return e.trim().toLowerCase();
      };

      return n(t).includes(n(r));
    },
        d = function d(e) {
      return e.label;
    },
        y = function y(e) {
      var t = e.node,
          r = e.nodeName,
          n = e.matchSearch,
          o = void 0 === n ? p : n,
          a = e.locale,
          y = void 0 === a ? d : a,
          v = c(e, ["node", "nodeName", "matchSearch", "locale"]),
          h = v.parent,
          m = v.level,
          b = v.openNodes,
          g = v.searchTerm,
          O = t.nodes,
          j = t.label,
          N = void 0 === j ? "unknown" : j,
          S = c(t, ["nodes", "label"]),
          w = [h, r].filter(function (e) {
        return e;
      }).join("/"),
          _ = l(O),
          P = _ && (b.includes(w) || !!g),
          k = y(_i2({
        label: N
      }, S)),
          x = !g || o(_i2({
        label: k,
        searchTerm: g
      }, S)),
          K = _i2(_i2(_i2({}, v), S), {
        label: k,
        hasNodes: _,
        isOpen: P,
        key: w
      }),
          T = s(O),
          C = P ? f(_i2(_i2({
        data: T,
        locale: y,
        matchSearch: o
      }, v), {
        parent: w,
        level: m + 1
      })) : [];

      return x ? u([K], C) : C;
    },
        v = (0, o["default"])(f);

    t["default"] = v;
  }, function (e, t) {
    var r = Object.prototype.hasOwnProperty,
        n = Object.prototype.toString;

    e.exports = function (e) {
      if (null == e) return !0;
      if ("boolean" == typeof e) return !1;
      if ("number" == typeof e) return 0 === e;
      if ("string" == typeof e) return 0 === e.length;
      if ("function" == typeof e) return 0 === e.length;
      if (Array.isArray(e)) return 0 === e.length;
      if (e instanceof Error) return "" === e.message;
      if (e.toString == n) switch (e.toString()) {
        case "[object File]":
        case "[object Map]":
        case "[object Set]":
          return 0 === e.size;

        case "[object Object]":
          for (var t in e) {
            if (r.call(e, t)) return !1;
          }

          return !0;
      }
      return !1;
    };
  }, function (e, t) {
    function r(e, t, r, n) {
      var o,
          a = null == (o = n) || "number" == typeof o || "boolean" == typeof o ? n : r(n),
          i = t.get(a);
      return void 0 === i && (i = e.call(this, n), t.set(a, i)), i;
    }

    function n(e, t, r) {
      var n = Array.prototype.slice.call(arguments, 3),
          o = r(n),
          a = t.get(o);
      return void 0 === a && (a = e.apply(this, n), t.set(o, a)), a;
    }

    function o(e, t, r, n, o) {
      return r.bind(t, e, n, o);
    }

    function a(e, t) {
      return o(e, this, 1 === e.length ? r : n, t.cache.create(), t.serializer);
    }

    function i() {
      return JSON.stringify(arguments);
    }

    function c() {
      this.cache = Object.create(null);
    }

    c.prototype.has = function (e) {
      return e in this.cache;
    }, c.prototype.get = function (e) {
      return this.cache[e];
    }, c.prototype.set = function (e, t) {
      this.cache[e] = t;
    };
    var u = {
      create: function create() {
        return new c();
      }
    };
    e.exports = function (e, t) {
      var r = t && t.cache ? t.cache : u,
          n = t && t.serializer ? t.serializer : i;
      return (t && t.strategy ? t.strategy : a)(e, {
        cache: r,
        serializer: n
      });
    }, e.exports.strategies = {
      variadic: function variadic(e, t) {
        return o(e, this, n, t.cache.create(), t.serializer);
      },
      monadic: function monadic(e, t) {
        return o(e, this, r, t.cache.create(), t.serializer);
      }
    };
  }, function (e, t, r) {
    var n;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var r = {}.hasOwnProperty;

      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];

          if (n) {
            var a = typeof n;
            if ("string" === a || "number" === a) e.push(n);else if (Array.isArray(n) && n.length) {
              var i = o.apply(null, n);
              i && e.push(i);
            } else if ("object" === a) for (var c in n) {
              r.call(n, c) && n[c] && e.push(c);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (o["default"] = o, e.exports = o) : void 0 === (n = function () {
        return o;
      }.apply(t, [])) || (e.exports = n);
    }();
  }]);
});